PJQ.views.rfi.RFISettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.RFI, 'RFI-Settings'),
        onChange: null
    },
    events: {
        'change .select-column': 'columnSelected',
        'click .settings-save': 'onSave'
    },
    beforeFirstRender: function () {
        this.listenTo(this.model, 'fetch', this.render);
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            userSettings: this.options.userSettings
        };
    },
    afterRender: function () {
        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
        if (this.model) {
            new PJQ.Binder(this.$el, this.model, {
                watchElements: [
                    'input'
                ],
                afterChange: _.bind(function () {
                    this.onChange();
                }, this)
            });
        }

        if (this.options.userSettings != null) {
            this.rowsPerPageSelectPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.rows-per-page'),
                defaultValue: this.options.userSettings.getSettings(PJQ.constants.rfi.view.RFIS).rowsPerPage,
                onChange: _.bind(function (value) {
                    this.onChange();
                }, this)
            });

            if (this.options.rfiView != null) {
                this.dataTable = new PJQ.views.dataTables.DataTable({
                    el: this.$('div.column-settings'),
                    data: this.options.rfiView.getColumns(true),
                    isHideSearch: true,
                    order: [],
                    columns: [
                        {"data": "title", "title": "Column", "orderable": false},
                        {
                            "data": "visible",
                            "title": "Show",
                            "orderable": false,
                            "searchable": false,
                            "render": _.bind(function (data) {
                                return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                            }, this),
                            "width": '10%'
                        }
                    ],
                    dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
                });
            }
        }
    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onChange: function () {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.model);
        }
    }
});

PJQ.views.rfi.RFISettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.RFI, 'Modal-RFI-Settings'),
        subTemplates: {},
        maxWidth: 500,
        onSave: _.noop
    },
    events: {
        'click .settings-save': 'onSave'
    },
    beforeModalCreated: function () {
        PJQ.app.session.project.fetchRFISettings(_.bind(function (settings) {
            this.model = settings;
            this.render();
        }, this));
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model
        };
    },
    afterRender: function () {
        if (typeof this.model !== 'undefined' && this.model.isFetched) {
            this.settingsView = new PJQ.views.rfi.RFISettings({
                el: this.$('.modal-body'),
                model: this.model,
                userSettings: this.options.userSettings,
                rfiView: this.options.rfiView
            })
        }
    },
    onSave: function () {
        let loader = new PJQ.Loader(this.$('.modal-content'));
        this.options.rfiView.options.userSettings.getSettings(PJQ.constants.rfi.view.RFIS).rowsPerPage = parseInt(this.settingsView.rowsPerPageSelectPicker.getValue());
        let columns = this.options.rfiView.options.userSettings.getSettings(PJQ.constants.rfi.view.RFIS).columns;
        _.each(this.settingsView.dataTable.dataTable.data(), function (row) {
            if (row.visible) {
                if (columns.indexOf(row.columnData) === -1)
                    columns.push(row.columnData);
            } else {
                columns = _.filter(columns, function (column) {
                    return (column != row.columnData);
                });
            }
        });
        this.options.rfiView.options.userSettings.getSettings(PJQ.constants.rfi.view.RFIS).columns = columns;
        this.options.rfiView.options.userSettings.save(null, {
            success: _.bind(function () {
                this.model.put(null, {
                    success: _.bind(function () {
                        this.options.onSave();
                        PJQ.notifications.notify.successNotify({
                            message: 'RFI settings saved'
                        });
                        this.removeModal();
                    }, this),
                    error: function () {
                        loader.remove();
                    }
                });
            }, this),
            error: function () {
                loader.remove();
            }
        });
    }
});
